// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import * as React from '@plesk/ui-library';

export default React;
export * from '@plesk/ui-library';
